import processingInboxCertificationReducer from "./processingInboxCertificationReducer";

const processingInboxReducer = {
    processingInboxCertification: processingInboxCertificationReducer
}

export default processingInboxReducer;